import { render, staticRenderFns } from "./contentManagement.vue?vue&type=template&id=28801be3&scoped=true&"
import script from "./contentManagement.vue?vue&type=script&lang=ts&"
export * from "./contentManagement.vue?vue&type=script&lang=ts&"
import style1 from "./contentManagement.vue?vue&type=style&index=1&id=28801be3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28801be3",
  null
  
)

export default component.exports